// Return a noun-phrase for the first `limit`-many of `quantity`-many items.
// For example: "345", "first 100 of 345".
export function makeRangeDescription(quantity: number, limit: number) {
  const desc = [];
  const truncated = quantity > limit;
  if (truncated) {
    desc.push('first', limit, 'of');
  }
  desc.push(quantity);
  return desc.join(' ');
}

// Given an array of values, return a subsequence where only the first
// occurrence of any given value is present.
export function uniq<T>(as: T[]): T[] {
  const set = new Set();
  return as.filter((a) => {
    if (set.has(a)) {
      return false;
    }
    set.add(a);
    return true;
  });
}
